<template>
  <div>
    <v-progress-linear v-if="syncInProgress" indeterminate></v-progress-linear>
    <br />
    <v-autocomplete
      v-model="clientData.app"
      label="Select App"
      :items="availableApps"
      item-text="name"
      item-value="value"
      filled
      rounded
    ></v-autocomplete>

    <v-autocomplete
      v-if="
        clientData.app &&
          availableApps &&
          availableApps.find(o => o.value === clientData.app).availableTypes
      "
      v-model="clientData.type"
      :items="
        availableApps.find(o => o.value === clientData.app).availableTypes
      "
      label="Select Client Type"
      item-text="name"
      item-value="value"
      filled
      rounded
    ></v-autocomplete>

    <v-autocomplete
      v-if="clientData.app && clientData.type"
      v-model="clientData.id"
      :items="initialLoadedData[clientData.app][clientData.type]"
      :label="
        availableApps
          .find(o => o.value === clientData.app)
          .availableTypes.find(o => o.value === clientData.type).name
      "
      :item-text="
        availableApps
          .find(o => o.value === clientData.app)
          .availableTypes.find(o => o.value === clientData.type).nameKey
      "
      :item-value="
        availableApps
          .find(o => o.value === clientData.app)
          .availableTypes.find(o => o.value === clientData.type).valueKey
      "
      filled
      rounded
    ></v-autocomplete>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      availableApps: [],
      accessTokens: {},
      syncInProgress: false,
      clientData: {},
      initialLoadedData: {}
    };
  },
  watch: {
    "clientData.id": {
      async handler() {
        this.syncInProgress = true;
        const resolvedClient = await this.resolveFederatedClient(
          this.clientData
        );
        this.syncInProgress = false;
        this.$emit("input", resolvedClient.slug);
        this.$emit("clientData", resolvedClient);
      }
    }
  },
  async mounted() {
    await this.loadMetaData();
    await this.loadInitialData();
  },
  methods: {
    async loadInitialData() {
      console.log(this.availableApps);
      for (const index in this.availableApps) {
        const app = this.availableApps[index];
        this.initialLoadedData[app.value] = {};
        if (Array.isArray(app.availableTypes)) {
          for (const typIndex in app.availableTypes) {
            const typeObj = app.availableTypes[typIndex];

            if (typeObj.endpoint) {
              let getFunc = async url => {
                let accessToken = await this.getAccessToken(app.value);
                try {
                  let conf = {
                    headers: {
                      Authorization: accessToken
                    }
                  };
                  let { data } = await axios.get(url, conf);
                  this.initialLoadedData[app.value][typeObj.value] = data;
                } catch (e) {
                  console.log("this is error", e.response);
                  if ([401, 403].indexOf(e.response.status) !== -1) {
                    this.$auth.$storage.removeLocalStorage(`fcat_${app.value}`);
                    await getFunc(url);
                  }
                }
              };

              await getFunc(`${app.baseUrl}${typeObj.endpoint}`);
            } else {
              this.initialLoadedData[app.value][typeObj.value] = [];
            }
          }
        }
      }
    },

    async loadMetaData() {
      const { data } = await this.$axios.get(
        "/api/v1/crm/clients/get_foreign_client_meta_data/"
      );
      this.availableApps = data;
    },

    async getAccessToken(app) {
      // todo delete token on error
      if (this.$auth.$storage.getLocalStorage(`fcat_${app}`)) {
        return this.$auth.$storage.getLocalStorage(`fcat_${app}`);
      } else {
        const { data } = await this.$axios.get(
          `/api/v1/crm/clients/get_access_token/?app=${app}`
        );

        this.$auth.$storage.setLocalStorage(
          `fcat_${app}`,
          data["access_token"]
        );
        return data["access_token"];
      }
    },

    async resolveFederatedClient(resolverData) {
      const { data } = await this.$axios.post(
        "/api/v1/crm/clients/resolve_federated_client/",
        {
          ...resolverData,
          organization: this.$store.state.shell.currentOrganizationId
        }
      );
      return data;
    }
  }
};
</script>
